import { ApolloLink } from "@apollo/client";
import { authManager } from "../global";

export const createAuthLink = () => {
    return new ApolloLink((operation, forward) => {
        authManager.setAuthHeaders(operation);
        return forward(operation);
    });
};
